const ButtonTypeEnum = Object.freeze({
    LINK1: "Link1",
    LINK2: "Link2",
    NAVLINK: "Navlink"
})

export default ButtonTypeEnum;